import React from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'reactstrap';
import { Button } from '@stormideas/react-sdk';
import { matchPath, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { compose, withState, withHandlers } from 'recompose';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolder } from '@fortawesome/pro-solid-svg-icons';
import './FolderListItem.scss';

/** A folder that can contain child folders for creating a tree. */

const enhance = compose(
  withRouter,
  withState('isOpen', 'setOpen', props => {
    const {
      location: { pathname },
      route,
    } = props;

    return !!matchPath(pathname, route);
  }),
  withHandlers({
    toggle: props => () => {
      props.setOpen(!props.isOpen);
      // prevent the focus state hanging about
      document.activeElement.blur();
    },
  })
);

const FolderListItem = ({
  items,
  className,
  icon,
  isOpen,
  path,
  title,
  toggle,
  children,
}) => (
  <React.Fragment>
    <li className={classnames(className, 'folder-list-item')}>
      {icon}
      <Link to={path} className="folder-title">
        {title}
      </Link>
      {items && (
        <Button
          className={classnames({ open: isOpen })}
          icon={<div className="lnr lnr-chevron-down" />}
          onClick={toggle}
          role="button"
          size="sm"
          type="button"
        />
      )}
    </li>
    {items && (
      <Collapse tag="ul" className="folder-list" isOpen={isOpen}>
        {children}
      </Collapse>
    )}
  </React.Fragment>
);

FolderListItem.propTypes = {
  /** Child folders */
  children: PropTypes.node,
  /** Custom `<li>` class name */
  className: PropTypes.string,
  /** Custom icon */
  icon: PropTypes.node,
  /** Default state */
  isOpen: PropTypes.bool,
  /** Child folders as an array */
  items: PropTypes.arrayOf(PropTypes.shape({})),
  /** Relative or absolute link */
  path: PropTypes.string,
  /** Folder name */
  title: PropTypes.string,
  /** Looks like this is added by recompose? */
  toggle: PropTypes.func.isRequired,
};

FolderListItem.defaultProps = {
  children: '',
  className: null,
  icon: <FontAwesomeIcon icon={faFolder} className="asset-icon folder-icon" />,
  isOpen: true,
  items: null,
  path: '',
  title: null,
};

export default enhance(FolderListItem);
